import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityBadges = () => {
  const securityFeatures = [
    {
      icon: "Shield",
      title: "SSL Encrypted",
      description: "256-bit encryption"
    },
    {
      icon: "Lock",
      title: "GDPR Compliant",
      description: "Data protection"
    },
    {
      icon: "ShieldCheck",
      title: "Secure Access",
      description: "2FA available"
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
      {securityFeatures?.map((feature, index) => (
        <div
          key={index}
          className="flex flex-col items-center text-center p-4 md:p-6 bg-muted/50 rounded-lg border border-border"
        >
          <div className="w-12 h-12 md:w-14 md:h-14 bg-primary/10 rounded-full flex items-center justify-center mb-3">
            <Icon name={feature?.icon} size={24} color="var(--color-primary)" />
          </div>
          <h3 className="text-sm md:text-base font-semibold text-foreground mb-1">
            {feature?.title}
          </h3>
          <p className="text-xs md:text-sm text-muted-foreground">
            {feature?.description}
          </p>
        </div>
      ))}
    </div>
  );
};

export default SecurityBadges;